/** @jsx jsx */

import { Spacing } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

import BundleConsoleHttpBase from '../BundleConsoleHttpBase';
import SimpleLog from '../Logs/SimpleLog';

const Styles = {
  logItem: css`
    &:not(:first-child) {
      margin-top: ${Spacing.small}px;
    }
  `,
};

type Log = {
  date: string;
  id: string;
  message: string;
  title: string;
};

type Props = {
  isLoading: boolean;
  logs: Array<Log>;
  onClickTestAgain: () => void;
};

function BundleConsoleBase({ isLoading, logs, onClickTestAgain }: Props) {
  return (
    <BundleConsoleHttpBase
      isLoading={isLoading}
      onClickTestAgain={onClickTestAgain}
    >
      {logs.length > 0 ? (
        <ul>
          <li css={Styles.logItem}>
            {logs.map((log, index) => (
              <SimpleLog
                date={log.date}
                isInitiallyExpanded={index === 0}
                key={log.id}
                message={log.message}
                title={log.title}
              />
            ))}
          </li>
        </ul>
      ) : null}
    </BundleConsoleHttpBase>
  );
}

BundleConsoleBase.defaultProps = {
  isLoading: false,
  logs: [],
};

export default BundleConsoleBase;
